import {
  inventoryAdjustmentReasonIdFormat,
  locationIdFormat,
  productIdFormat,
} from "@redotech/redo-model/ids";
import * as z from "zod";

export const adjustInventory = {
  name: "adjustInventory" as const,
  input: z.object({
    notes: z.string().optional(),
    reasonId: inventoryAdjustmentReasonIdFormat.schema.nullish(),
    adjustments: z.array(
      z.union([
        z.object({
          productId: productIdFormat.schema,
          locationId: locationIdFormat.schema,
          quantity: z.number(),
          reason: z.string(),
        }),
        z.object({
          productId: productIdFormat.schema,
          locationId: locationIdFormat.schema,
          delta: z.number(),
          reason: z.string(),
        }),
      ]),
    ),
  }),
  output: z.object({ success: z.boolean() }),
};
